import { logout } from '@/services/session';
import { LogoutOutlined, SnippetsOutlined, SwapOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Menu, message, Spin } from 'antd';
import { stringify } from 'querystring';
import type { MenuInfo } from 'rc-menu/lib/interface';
// import type { MenuProps } from 'antd';
import React, { useCallback, useState } from 'react';
import { history, useModel } from 'umi';
import HeaderDropdown from '../HeaderDropdown';
// 切换身份
import Identity from './components/Identity';
// 申请加入机构
import Apply from './components/Apply';
import { clearSessionToken } from '@/access';

import styles from './index.less';
import { getHost } from '@/utils/format'
// const LoginPageUrl = SSOServer ? `${SSOServer}/login` : '';

export type GlobalHeaderRightProps = {
  menu?: boolean;
};

/**
 * 退出登录，并且将当前的 url 保存
 */
const loginOut = async () => {
  const res = await logout();
  if (res.code === '00000') {
    clearSessionToken();
    message.success('退出成功');
  }
  const { query = {}, pathname } = history.location;
  const { redirect } = query;
  // Note: There may be security issues, please note
  if (window.location.pathname !== '/user/login' && !redirect) {
    // window.location.href = `${SSOServer}/login`;
    history.replace({
      pathname: '/user/login',
      search: stringify({
        redirect: pathname,
      }),
    });
  }
};

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu }) => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const { dispatch } = useModel('system');
  const [checkBody, setCheckBody] = useState(false);
  const [institutions, setInstitutions] = useState(false);

  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event;
      if (key === 'logout') {
        initialState?.ws.close();
        setInitialState((s) => ({ ...s, currentUser: undefined, menus: undefined }));
        dispatch({ type: 'CHANGESTATE', payload: { tabList: [] } });
        loginOut();

        return;
      } else if (key === 'checkBody') {
        setCheckBody(true);
      } else if (key === 'institutions') {
        setInstitutions(true);
      } else {
        history.push(`${key}`);
      }
    },
    [setInitialState],
  );

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser }: any = initialState;

  if (!currentUser || !currentUser.userName) {
    return loading;
  }
  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
      {/* // userType === 2 是机构的 */}
      {Number(currentUser?.userType) !== 2 ? (
        <>
          {menu && (
            <Menu.Item key="/account/center">
              <UserOutlined />
              个人中心
            </Menu.Item>
          )}
          {/* {menu && (
            <Menu.Item key="checkBody">
              <SnippetsOutlined />
              切换身份
            </Menu.Item>
          )}
          {menu && (
            <Menu.Item key="institutions">
              <SwapOutlined />
              申请加入机构
            </Menu.Item>
          )} */}
        </>
      ) : (
        <></>
      )}
      {menu && <Menu.Divider />}

      <Menu.Item key="logout">
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  );

  // const newMenu: MenuProps['items'] = [
  //   Number(currentUser?.userType) !== 2 && menu
  //     ? {
  //         label: (
  //           <>
  //             <UserOutlined />
  //             个人中心
  //           </>
  //         ),
  //         key: '/account/center',
  //       }
  //     : null,
  //   Number(currentUser?.userType) !== 2 && menu
  //     ? {
  //         label: (
  //           <>
  //             <SnippetsOutlined />
  //             切换身份
  //           </>
  //         ),
  //         key: 'checkBody',
  //       }
  //     : null,
  //   Number(currentUser?.userType) !== 2 && menu
  //     ? {
  //         label: (
  //           <>
  //             <SwapOutlined />
  //             申请加入机构
  //           </>
  //         ),
  //         key: 'institutions',
  //       }
  //     : null,
  //   menu
  //     ? {
  //         type: 'divider',
  //       }
  //     : null,
  //   {
  //     label: (
  //       <>
  //         <LogoutOutlined />
  //         退出登录
  //       </>
  //     ),
  //     key: 'logout',
  //   },
  // ];
  return (
    <div>
      <HeaderDropdown
        overlay={
          menuHeaderDropdown
        } /* menu={{ items: newMenu, onClick: onMenuClick }} overlayClassName={styles.menu} */
      >
        <span className={`${styles.action} ${styles.account}`}>
          <Avatar
            size="small"
            className={styles.avatar}
            src={`${getHost()}` + currentUser.avatar}
            alt="avatar"
          />
          <span className={`${styles.name} anticon`}>{currentUser.personName}</span>
        </span>
      </HeaderDropdown>
      {/* 切换身份 */}
      {checkBody && <Identity visible={checkBody} setVisible={setCheckBody} />}
      {/* 申请加入机构 */}
      <Apply visible={institutions} setVisible={setInstitutions} />
    </div>
  );
};

export default AvatarDropdown;
